﻿import type { ReservationState, RoomBookingState } from './types';

import { useModelState } from '@/utils/useModelState';

import { Oval } from 'react-loader-spinner'

import { default as classNames } from "classnames";

import { useEffect, useState, type ReactNode } from 'react';

import { RoomPriceDialogComponent } from './RoomPriceDialogComponent';
import { countCalendarDaysBetween } from '@/utils/utils';


export function RoomPriceComponent({ reservationState, roomBookingState }: RoomPriceComponentProps) {

    const [price] = useModelState(roomBookingState.CalculatedPrice);
    const [isLoading] = useModelState(roomBookingState.Price.isLoading);

    const discounted = price.totalBaseAmount > price.totalPayableAmount;

    const [dialogVisible, setDialogVisible] = useState(false);

    const [checkIn] = useModelState(roomBookingState.CheckIn);
    const [checkOut] = useModelState(roomBookingState.CheckOut);

    const nights = countCalendarDaysBetween(checkIn, checkOut) - 1;

    const nightsText = nights === 1 ? 'Night' : 'Nights';

    return (
        <div className="flex gap-0.5" >
            <div className="flex cursor-pointer gap-2" onClick={() => {
                setDialogVisible(true);
            }}>
                <div>
                    {nights} {nightsText} -
                </div>
                <div className={classNames({ 'line-through': discounted })}>
                    {price.totalBaseAmount.toLocaleString('en-NZ', { style: 'currency', currency: 'THB' })}
                </div>
                {discounted && (
                    <div>
                        {price.totalPayableAmount.toLocaleString('en-NZ', { style: 'currency', currency: 'THB' })}
                    </div>
                )}
            </div>
            <div>
                {isLoading ?
                    <div>
                        <Oval
                            visible={true}
                            height="20"
                            width="20"
                            ariaLabel="oval-loading"
                            color="#000000"
                            secondaryColor="#000000"
                        />
                    </div> : null}
            </div>
            <RoomPriceDialogComponent
                reservationState={reservationState}
                roomBookingState={roomBookingState}
                visible={dialogVisible}
                closed={() => {
                    setDialogVisible(false);
                }} />
        </div>
    );
}

export interface RoomPriceComponentProps {
    reservationState: ReservationState;
    roomBookingState: RoomBookingState;
}
